var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPricebg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 408,
    height: 153,
    viewBox: "0 0 408 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_364_18746)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 408,
    height: 153,
    rx: 6,
    fill: "#5AC8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.955 144.027C396.449 146.242 402.338 147.382 408.285 147.382V59.243C402.338 59.243 396.449 60.3829 390.955 62.5976C385.461 64.8123 380.469 68.0584 376.264 72.1507C372.059 76.2429 368.723 81.101 366.447 86.4478C364.171 91.7945 363 97.5251 363 103.312C363 109.1 364.171 114.83 366.447 120.177C368.723 125.524 372.059 130.382 376.264 134.474C380.469 138.566 385.461 141.813 390.955 144.027Z",
    fill: "#5856D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.285 59.243V6C404.692 6 401.135 6.68858 397.816 8.02644C394.497 9.3643 391.482 11.3252 388.941 13.7973C386.401 16.2693 384.386 19.204 383.011 22.4339C381.637 25.6638 380.929 29.1255 380.929 32.6215C380.929 36.1175 381.637 39.5793 383.011 42.8091C384.386 46.039 386.401 48.9737 388.941 51.4458C391.482 53.9178 394.497 55.8787 397.816 57.2166C401.135 58.5544 404.692 59.243 408.285 59.243Z",
    fill: "#5856D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.00012207,
    width: 300,
    height: 153,
    fill: "#5856D6"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_364_18746)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_364_18746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.815 41.2282V28.9857C168.815 27.3911 168.501 25.8122 167.891 24.3389C167.281 22.8656 166.387 21.527 165.26 20.3993C164.132 19.2717 162.794 18.3772 161.321 17.7669C159.847 17.1566 158.268 16.8425 156.674 16.8425V37.3468C156.674 40.567 157.953 43.6553 160.23 45.9325C162.507 48.2097 165.595 49.4894 168.815 49.49V41.2282Z",
    fill: "url(#paint0_linear_364_18746)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.323 38.3159H167.078C164.561 37.9656 162.213 36.8499 160.352 35.1203C158.491 33.3906 157.207 31.1306 156.674 28.6465V38.3159C156.674 41.5361 157.953 44.6244 160.23 46.9016C162.507 49.1788 165.595 50.4585 168.815 50.4591H184.473C184.474 48.8637 184.16 47.284 183.549 45.8101C182.938 44.3362 182.043 42.9971 180.915 41.8693C179.786 40.7416 178.447 39.8473 176.973 39.2376C175.498 38.6278 173.918 38.3147 172.323 38.3159Z",
    fill: "url(#paint1_linear_364_18746)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M186.205 29.6732V20.5164H189.315V27.2793H193.479V29.6732H186.205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.407 29.6732L202.439 20.5164H205.496L209.528 29.6732H206.313L203.335 21.9815H204.547L201.569 29.6732H198.407ZM200.805 28.0773L201.595 25.8535H205.838L206.629 28.0773H200.805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.948 20.5164H224.057V29.6732H220.948V20.5164ZM218.075 29.6732H214.965V20.5164H218.075V29.6732ZM221.158 26.2982H217.864V23.7605H221.158V26.2982Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.829 29.8825C232.109 29.8825 231.459 29.7691 230.879 29.5424C230.299 29.3069 229.816 28.9668 229.43 28.522L231.103 26.5599C231.349 26.8564 231.591 27.0831 231.828 27.2401C232.065 27.3883 232.311 27.4625 232.566 27.4625C233.233 27.4625 233.567 27.0831 233.567 26.3244V22.8448H230.431V20.5164H236.637V26.1413C236.637 27.3971 236.312 28.3345 235.662 28.9537C235.012 29.5729 234.068 29.8825 232.829 29.8825Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.81 29.6732L245.842 20.5164H248.899L252.931 29.6732H249.716L246.738 21.9815H247.951L244.973 29.6732H241.81ZM244.208 28.0773L244.999 25.8535H249.242L250.033 28.0773H244.208Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.045 44.0626L197.873 40.6745L201.352 36.8679H204.739L200.838 41.1324L199.112 42.8853L198.045 44.0626ZM195.264 46.0248V36.8679H198.321V46.0248H195.264ZM201.326 46.0248L198.611 42.4667L200.627 40.3475L204.923 46.0248H201.326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.817 46.0248L212.849 36.8679H215.906L219.938 46.0248H216.723L213.745 38.333H214.957L211.979 46.0248H208.817ZM211.215 44.4288L212.006 42.205H216.248L217.039 44.4288H211.215Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.376 46.0248V36.8679H227.932L231.621 42.846H230.277L233.861 36.8679H236.418L236.444 46.0248H233.611L233.585 41.1062H234.033L231.582 45.2006H230.211L227.655 41.1062H228.209V46.0248H225.376Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.303 46.234C245.889 46.234 244.786 45.8547 243.996 45.096C243.205 44.3373 242.81 43.2733 242.81 41.9042V36.8679H245.92V41.8126C245.92 42.5103 246.047 43.0074 246.302 43.3039C246.556 43.5916 246.899 43.7355 247.33 43.7355C247.769 43.7355 248.111 43.5916 248.357 43.3039C248.612 43.0074 248.739 42.5103 248.739 41.8126V36.8679H251.796V41.9042C251.796 43.2733 251.401 44.3373 250.611 45.096C249.82 45.8547 248.717 46.234 247.303 46.234Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_364_18746",
    x1: 171.506,
    y1: 16.9104,
    x2: 160.982,
    y2: 36.4359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6DFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#90D4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744792,
    stopColor: "#76CEF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5AC8FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_364_18746",
    x1: 178.351,
    y1: 35.3044,
    x2: 161.326,
    y2: 44.6032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5AC8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0666667,
    stopColor: "#5BC8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133333,
    stopColor: "#5DC9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#60CAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266667,
    stopColor: "#65CBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#6BCCFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#72CEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466667,
    stopColor: "#7BD1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533333,
    stopColor: "#83D3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#8BD5FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#93D7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733333,
    stopColor: "#99D8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#9EDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866667,
    stopColor: "#A1DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933333,
    stopColor: "#A3DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4DBFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_364_18746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 408,
    height: 153,
    rx: 6,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_364_18746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102.871,
    height: 34.8923,
    fill: "white",
    transform: "translate(153 16.1077)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_364_18746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.8612,
    height: 35.2699,
    fill: "white",
    transform: "translate(155.204 16.1077)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricebg);
export default __webpack_public_path__ + "static/media/pricebg.86c7f425169b23ff181a6e87e56aa20d.svg";
export { ForwardRef as ReactComponent };